// import React, { useState } from 'react';

// const EmployeeList = () => {
//   // Sample employee data
//   const [employees, setEmployees] = useState([
//     {
//       id: 1,
//       employeeId: 'EMP001',
//       fullName: 'John Doe',
//       email: 'john.doe@company.com',
//       phone: '+1 (555) 123-4567',
//       department: 'IT',
//       designation: 'Developer',
//       reportingManager: 'Sarah Johnson',
//       dateOfJoining: '2022-03-15',
//       status: 'Active',
//       profilePic: 'https://randomuser.me/api/portraits/men/1.jpg'
//     },
//     {
//       id: 2,
//       employeeId: 'EMP002',
//       fullName: 'Jane Smith',
//       email: 'jane.smith@company.com',
//       phone: '+1 (555) 987-6543',
//       department: 'HR',
//       designation: 'Manager',
//       reportingManager: 'Michael Brown',
//       dateOfJoining: '2021-08-22',
//       status: 'Active',
//       profilePic: 'https://randomuser.me/api/portraits/women/2.jpg'
//     },
//     {
//       id: 3,
//       employeeId: 'EMP003',
//       fullName: 'Robert Johnson',
//       email: 'robert.j@company.com',
//       phone: '+1 (555) 456-7890',
//       department: 'Sales',
//       designation: 'Executive',
//       reportingManager: 'Lisa Williams',
//       dateOfJoining: '2023-01-10',
//       status: 'Inactive',
//       profilePic: 'https://randomuser.me/api/portraits/men/3.jpg'
//     }
//   ]);

//   const [filters, setFilters] = useState({
//     department: '',
//     designation: '',
//     status: '',
//     search: ''
//   });

//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(10);
//   const [sortConfig, setSortConfig] = useState({ key: '', direction: '' });
//   const [viewEmployee, setViewEmployee] = useState(null);

//   // Departments and designations options
//   const departments = ['All', 'HR', 'IT', 'Sales', 'Marketing', 'Finance', 'Operations'];
//   const designations = ['All', 'Manager', 'Developer', 'Designer', 'Analyst', 'Executive', 'Intern'];
//   const statusOptions = ['All', 'Active', 'Inactive'];

//   // Handle filter changes
//   const handleFilterChange = (e) => {
//     const { name, value } = e.target;
//     setFilters({
//       ...filters,
//       [name]: value
//     });
//     setCurrentPage(1);
//   };

//   // Handle search
//   const handleSearch = (e) => {
//     setFilters({
//       ...filters,
//       search: e.target.value
//     });
//     setCurrentPage(1);
//   };

//   // Handle sort
//   const handleSort = (key) => {
//     let direction = 'ascending';
//     if (sortConfig.key === key && sortConfig.direction === 'ascending') {
//       direction = 'descending';
//     }
//     setSortConfig({ key, direction });
//   };

//   // Handle back navigation
//   const handleBack = () => {
//     window.history.back();
//   };

//   // Filter and sort employees
//   const filteredEmployees = employees.filter(employee => {
//     return (
//       (filters.department === '' || filters.department === 'All' || employee.department === filters.department) &&
//       (filters.designation === '' || filters.designation === 'All' || employee.designation === filters.designation) &&
//       (filters.status === '' || filters.status === 'All' || employee.status === filters.status) &&
//       (filters.search === '' || 
//         employee.fullName.toLowerCase().includes(filters.search.toLowerCase()) ||
//         employee.employeeId.toLowerCase().includes(filters.search.toLowerCase()) ||
//         employee.email.toLowerCase().includes(filters.search.toLowerCase()))
//     );
//   });

//   // Sort employees
//   const sortedEmployees = [...filteredEmployees].sort((a, b) => {
//     if (sortConfig.key) {
//       if (a[sortConfig.key] < b[sortConfig.key]) {
//         return sortConfig.direction === 'ascending' ? -1 : 1;
//       }
//       if (a[sortConfig.key] > b[sortConfig.key]) {
//         return sortConfig.direction === 'ascending' ? 1 : -1;
//       }
//     }
//     return 0;
//   });

//   // Pagination
//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = sortedEmployees.slice(indexOfFirstItem, indexOfLastItem);
//   const totalPages = Math.ceil(sortedEmployees.length / itemsPerPage);

//   // Change page
//   const paginate = (pageNumber) => setCurrentPage(pageNumber);

//   // View employee details
//   const handleViewEmployee = (employee) => {
//     setViewEmployee(employee);
//   };

//   // Close view modal
//   const handleCloseModal = () => {
//     setViewEmployee(null);
//   };

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 py-8 px-4">
//       <div className="max-w-7xl mx-auto">
//         {/* Header with back button */}
//         <div className="mb-8 flex items-center">
//           <button 
//             onClick={handleBack}
//             className="mr-4 p-2 rounded-full hover:bg-blue-100 transition-colors duration-200"
//             aria-label="Go back"
//           >
//             <svg 
//               xmlns="http://www.w3.org/2000/svg" 
//               className="h-6 w-6 text-blue-600" 
//               fill="none" 
//               viewBox="0 0 24 24" 
//               stroke="currentColor"
//             >
//               <path 
//                 strokeLinecap="round" 
//                 strokeLinejoin="round" 
//                 strokeWidth={2} 
//                 d="M10 19l-7-7m0 0l7-7m-7 7h18" 
//               />
//             </svg>
//           </button>
//           <div>
//             <h1 className="text-3xl font-bold text-gray-800 mb-2">📋 Employee List</h1>
//             <p className="text-gray-600">Manage your organization's employees efficiently</p>
//           </div>
//         </div>

//         {/* Menu Options */}
//         <div className="bg-white rounded-lg shadow-md p-6 mb-6">
//           <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-6">
//             <div className="flex flex-col sm:flex-row gap-3">
//               <button className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-md flex items-center">
//                 <span className="mr-2">ž•</span> Add Employee
//               </button>

//               <div className="flex gap-3">
//                 <select 
//                   name="department" 
//                   value={filters.department}
//                   onChange={handleFilterChange}
//                   className="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 >
//                   <option value="All">All Departments</option>
//                   {departments.filter(dept => dept !== 'All').map(dept => (
//                     <option key={dept} value={dept}>{dept}</option>
//                   ))}
//                 </select>

//                 <select 
//                   name="designation" 
//                   value={filters.designation}
//                   onChange={handleFilterChange}
//                   className="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 >
//                   <option value="All">All Designations</option>
//                   {designations.filter(des => des !== 'All').map(des => (
//                     <option key={des} value={des}>{des}</option>
//                   ))}
//                 </select>

//                 <select 
//                   name="status" 
//                   value={filters.status}
//                   onChange={handleFilterChange}
//                   className="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 >
//                   <option value="All">All Status</option>
//                   {statusOptions.filter(status => status !== 'All').map(status => (
//                     <option key={status} value={status}>{status}</option>
//                   ))}
//                 </select>
//               </div>
//             </div>

//             <div className="flex items-center gap-3">
//               <div className="relative">
//                 <input
//                   type="text"
//                   placeholder="Search by name, ID, or email"
//                   value={filters.search}
//                   onChange={handleSearch}
//                   className="border border-gray-300 rounded-md pl-10 pr-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 w-full md:w-64"
//                 />
//                 <span className="absolute left-3 top-2.5 text-gray-400"></span>
//               </div>

//               <button className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-md flex items-center">
//                 <span className="mr-2">‡</span> Export
//               </button>
//             </div>
//           </div>

//           {/* Employee Table */}
//           <div className="overflow-x-auto">
//             <table className="min-w-full divide-y divide-gray-200">
//               <thead className="bg-gray-50">
//                 <tr>
//                   <th 
//                     scope="col" 
//                     className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer"
//                     onClick={() => handleSort('employeeId')}
//                   >
//                     Employee ID {sortConfig.key === 'employeeId' && (sortConfig.direction === 'ascending' ? '↑' : '↓')}
//                   </th>
//                   <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                     Employee
//                   </th>
//                   <th 
//                     scope="col" 
//                     className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer"
//                     onClick={() => handleSort('email')}
//                   >
//                     Email {sortConfig.key === 'email' && (sortConfig.direction === 'ascending' ? '↑' : '↓')}
//                   </th>
//                   <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                     Phone
//                   </th>
//                   <th 
//                     scope="col" 
//                     className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer"
//                     onClick={() => handleSort('department')}
//                   >
//                     Department {sortConfig.key === 'department' && (sortConfig.direction === 'ascending' ? '↑' : '↓')}
//                   </th>
//                   <th 
//                     scope="col" 
//                     className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer"
//                     onClick={() => handleSort('designation')}
//                   >
//                     Designation {sortConfig.key === 'designation' && (sortConfig.direction === 'ascending' ? '↑' : '↓')}
//                   </th>
//                   <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                     Reporting Manager
//                   </th>
//                   <th 
//                     scope="col" 
//                     className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer"
//                     onClick={() => handleSort('dateOfJoining')}
//                   >
//                     Date of Joining {sortConfig.key === 'dateOfJoining' && (sortConfig.direction === 'ascending' ? '↑' : '↓')}
//                   </th>
//                   <th 
//                     scope="col" 
//                     className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer"
//                     onClick={() => handleSort('status')}
//                   >
//                     Status {sortConfig.key === 'status' && (sortConfig.direction === 'ascending' ? '↑' : '↓')}
//                   </th>
//                   <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                     Actions
//                   </th>
//                 </tr>
//               </thead>
//               <tbody className="bg-white divide-y divide-gray-200">
//                 {currentItems.map((employee) => (
//                   <tr key={employee.id} className="hover:bg-gray-50">
//                     <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
//                       {employee.employeeId}
//                     </td>
//                     <td className="px-6 py-4 whitespace-nowrap">
//                       <div className="flex items-center">
//                         <div className="h-10 w-10 flex-shrink-0">
//                           <img className="h-10 w-10 rounded-full object-cover" src={employee.profilePic} alt="" />
//                         </div>
//                         <div className="ml-4">
//                           <div className="text-sm font-medium text-gray-900">{employee.fullName}</div>
//                         </div>
//                       </div>
//                     </td>
//                     <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                       {employee.email}
//                     </td>
//                     <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                       {employee.phone}
//                     </td>
//                     <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                       {employee.department}
//                     </td>
//                     <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                       {employee.designation}
//                     </td>
//                     <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                       {employee.reportingManager}
//                     </td>
//                     <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                       {new Date(employee.dateOfJoining).toLocaleDateString()}
//                     </td>
//                     <td className="px-6 py-4 whitespace-nowrap">
//                       <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${employee.status === 'Active' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
//                         {employee.status}
//                       </span>
//                     </td>
//                     <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
//                       <button 
//                         onClick={() => handleViewEmployee(employee)}
//                         className="text-blue-600 hover:text-blue-900 mr-3"
//                       >
//                         View
//                       </button>
//                       <button className="text-indigo-600 hover:text-indigo-900 mr-3">
//                         Edit
//                       </button>
//                       <button className="text-red-600 hover:text-red-900">
//                         Delete
//                       </button>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>

//           {/* Pagination */}
//           <div className="flex items-center justify-between mt-6">
//             <div className="flex items-center">
//               <span className="text-sm text-gray-700 mr-4">
//                 Showing <span className="font-medium">{indexOfFirstItem + 1}</span> to <span className="font-medium">{Math.min(indexOfLastItem, sortedEmployees.length)}</span> of <span className="font-medium">{sortedEmployees.length}</span> results
//               </span>
//               <select 
//                 value={itemsPerPage}
//                 onChange={(e) => setItemsPerPage(Number(e.target.value))}
//                 className="border border-gray-300 rounded-md px-3 py-1 focus:outline-none focus:ring-2 focus:ring-blue-500"
//               >
//                 <option value="10">10 per page</option>
//                 <option value="20">20 per page</option>
//                 <option value="50">50 per page</option>
//               </select>
//             </div>

//             <div className="flex">
//               <button
//                 onClick={() => paginate(currentPage - 1)}
//                 disabled={currentPage === 1}
//                 className="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50"
//               >
//                 Previous
//               </button>
//               <button
//                 onClick={() => paginate(currentPage + 1)}
//                 disabled={currentPage === totalPages || totalPages === 0}
//                 className="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50"
//               >
//                 Next
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* View Employee Modal */}
//       {viewEmployee && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
//           <div className="bg-white rounded-lg shadow-xl max-w-md w-full">
//             <div className="px-6 py-4 border-b border-gray-200 flex justify-between items-center">
//               <h3 className="text-lg font-semibold text-gray-800">Employee Details</h3>
//               <button onClick={handleCloseModal} className="text-gray-400 hover:text-gray-500">
//                 <span className="text-2xl">Ã—</span>
//               </button>
//             </div>
//             <div className="px-6 py-4">
//               <div className="flex items-center mb-6">
//                 <img className="h-16 w-16 rounded-full object-cover" src={viewEmployee.profilePic} alt={viewEmployee.fullName} />
//                 <div className="ml-4">
//                   <h4 className="text-xl font-bold text-gray-800">{viewEmployee.fullName}</h4>
//                   <p className="text-gray-600">{viewEmployee.designation}, {viewEmployee.department}</p>
//                 </div>
//               </div>

//               <div className="space-y-3">
//                 <div className="flex">
//                   <span className="text-gray-600 w-32">Employee ID:</span>
//                   <span className="text-gray-800">{viewEmployee.employeeId}</span>
//                 </div>
//                 <div className="flex">
//                   <span className="text-gray-600 w-32">Email:</span>
//                   <span className="text-gray-800">{viewEmployee.email}</span>
//                 </div>
//                 <div className="flex">
//                   <span className="text-gray-600 w-32">Phone:</span>
//                   <span className="text-gray-800">{viewEmployee.phone}</span>
//                 </div>
//                 <div className="flex">
//                   <span className="text-gray-600 w-32">Reporting To:</span>
//                   <span className="text-gray-800">{viewEmployee.reportingManager}</span>
//                 </div>
//                 <div className="flex">
//                   <span className="text-gray-600 w-32">Date of Joining:</span>
//                   <span className="text-gray-800">{new Date(viewEmployee.dateOfJoining).toLocaleDateString()}</span>
//                 </div>
//                 <div className="flex">
//                   <span className="text-gray-600 w-32">Status:</span>
//                   <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${viewEmployee.status === 'Active' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
//                     {viewEmployee.status}
//                   </span>
//                 </div>
//               </div>
//             </div>
//             <div className="px-6 py-4 border-t border-gray-200 flex justify-end">
//               <button 
//                 onClick={handleCloseModal}
//                 className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
//               >
//                 Close
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default EmployeeList;










// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { Users, Sparkles, Star, Zap, Mail, Phone, Building2, Briefcase } from 'lucide-react';
// import { jwtDecode } from "jwt-decode";
// import AlertBox from '../../Components/AlertBox';
// const EmployeeLists = ({ onNavigate }) => {
//   const navigate = useNavigate();
//   const [employees, setEmployees] = useState([]);
//   const [projects, setProjects] = useState([]);
//   const [departments, setDepartments] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [showAlert, setShowAlert] = useState(null);
//   // Fetch employees from API
//   const fetchEmployees = async () => {
//     try {
//       const token = localStorage.getItem('authToken');
//       if (!token) {
//         console.error('No access token found');
//         return;
//       }

//       const response = await fetch('https://slateblue-mallard-430836.hostingersite.com/api/employees', {
//         headers: {
//           'Authorization': `Bearer ${token}`,
//           'Content-Type': 'application/json'
//         }
//       });

//       if (response.ok) {
//         const data = await response.json();
//         setEmployees(Array.isArray(data) ? data : []);
//         console.log('Employees fetched:', data);
//       } else {
//         console.error('Failed to fetch employees:', response.status);
//       }
//     } catch (error) {
//       console.error('Error fetching employees:', error);
//     }
//   };

//   // Fetch departments from API
//   const fetchDepartments = async () => {
//     try {
//       const token = localStorage.getItem('authToken');
//       if (!token) {
//         console.error('No access token found');
//         return;
//       }

//       const response = await fetch('https://slateblue-mallard-430836.hostingersite.com/api/departments', {
//         headers: {
//           'Authorization': `Bearer ${token}`,
//           'Content-Type': 'application/json'
//         }
//       });

//       if (response.ok) {
//         const data = await response.json();
//         setDepartments(Array.isArray(data) ? data : []);
//         console.log('Departments fetched:', data);
//       } else {
//         console.error('Failed to fetch departments:', response.status);
//       }
//     } catch (error) {
//       console.error('Error fetching departments:', error);
//     }
//   };

//   // Fetch projects from API
//   const fetchProjects = async () => {
//     try {
//       const token = localStorage.getItem('authToken');
//       if (!token) {
//         console.error('No access token found');
//         return;
//       }

//       const response = await fetch('https://slateblue-mallard-430836.hostingersite.com/api/projectsmgnt', {
//         headers: {
//           'Authorization': `Bearer ${token}`,
//           'Content-Type': 'application/json'
//         }
//       });

//       if (response.ok) {
//         const data = await response.json();
//         setProjects(Array.isArray(data) ? data : []);
//         console.log('Projects fetched:', data);
//       } else {
//         console.error('Failed to fetch projects:', response.status);
//       }
//     } catch (error) {
//       console.error('Error fetching projects:', error);
//     }
//   };

//   // Load all data on component mount
//   useEffect(() => {
//     const loadData = async () => {
//       setLoading(true);
//       await Promise.all([
//         fetchEmployees(),
//         fetchDepartments(),
//         fetchProjects()
//       ]);
//       setLoading(false);
//     };

//     loadData();
//   }, []);

//   // -------------------- Helper: Get Department Name --------------------
// const getDepartmentName = (employee) => {
//   console.log('Getting department for employee:', employee.teamMemberName || employee.name);
//   console.log('Employee department data:', employee.department);
//   console.log('Available departments count:', departments.length);

//   if (!employee.department) return 'N/A';

//   // Handle array of departments (most common case based on your data)
//   if (Array.isArray(employee.department)) {
//     console.log('Department is array with length:', employee.department.length);

//     const departmentNames = [];

//     employee.department.forEach((dept, index) => {
//       console.log(`Processing department ${index}:`, dept);

//       if (typeof dept === 'object' && dept !== null) {
//         // Department is an object with name
//         if (dept.name || dept.departmentName) {
//           departmentNames.push(dept.name || dept.departmentName);
//           console.log('✅ Found dept name from object:', dept.name || dept.departmentName);
//         } else if (dept._id || dept.id) {
//           // Department object has ID, look up name
//           const deptId = dept._id || dept.id;
//           const foundDept = departments.find(d => 
//             String(d._id) === String(deptId) || 
//             String(d.id) === String(deptId) ||
//             String(d.departmentId) === String(deptId)
//           );
//           if (foundDept) {
//             departmentNames.push(foundDept.name || foundDept.departmentName || `Department ${deptId}`);
//             console.log('✅ Found dept name from lookup:', foundDept.name || foundDept.departmentName);
//           } else {
//             departmentNames.push(`Dept ID: ${deptId}`);
//             console.log('❌ Dept not found for ID:', deptId);
//           }
//         }
//       } else if (typeof dept === 'string') {
//         // Department is a string ID
//         const foundDept = departments.find(d => 
//           String(d._id) === String(dept) || 
//           String(d.id) === String(dept) ||
//           String(d.departmentId) === String(dept)
//         );
//         if (foundDept) {
//           departmentNames.push(foundDept.name || foundDept.departmentName || `Department ${dept}`);
//           console.log('✅ Found dept name from string lookup:', foundDept.name || foundDept.departmentName);
//         } else {
//           departmentNames.push(`Dept ID: ${dept}`);
//           console.log('❌ Dept not found for string ID:', dept);
//         }
//       }
//     });

//     const result = departmentNames.length > 0 ? departmentNames.join(', ') : 'Unknown Department';
//     console.log('Final department names:', result);
//     return result;
//   }

//   // Handle single department object
//   if (typeof employee.department === 'object' && employee.department !== null) {
//     if (employee.department.name || employee.department.departmentName) {
//       return employee.department.name || employee.department.departmentName;
//     }
//     const deptId = employee.department._id || employee.department.id;
//     if (deptId) {
//       const foundDept = departments.find(d => 
//         String(d._id) === String(deptId) || 
//         String(d.id) === String(deptId) ||
//         String(d.departmentId) === String(deptId)
//       );
//       return foundDept ? (foundDept.name || foundDept.departmentName || `Department ${deptId}`) : `Dept ID: ${deptId}`;
//     }
//   }

//   // Handle single department string
//   if (typeof employee.department === 'string' && employee.department.trim() !== '') {
//     const deptId = employee.department.trim();
//     const foundDept = departments.find(d => 
//       String(d._id) === String(deptId) || 
//       String(d.id) === String(deptId) ||
//       String(d.departmentId) === String(deptId)
//     );
//     return foundDept ? (foundDept.name || foundDept.departmentName || `Department ${deptId}`) : `Dept ID: ${deptId}`;
//   }

//   return 'N/A';
// };

//   // ---------- Modern Glassmorphism Styles ----------
//   const containerStyle = {
//     padding: '2rem',
//     fontFamily: '"Inter", "Segoe UI", Roboto, sans-serif',
//     backgroundColor: '#f8fafc',
//     minHeight: '100vh',
//     overflow: 'hidden',
//   };

//   const backgroundOverlayStyle = {
//     position: 'absolute',
//     top: 0,
//     left: 0,
//     right: 0,
//     bottom: 0,
//     background: 'rgba(255, 255, 255, 0.1)',
//     backdropFilter: 'blur(20px)',
//     zIndex: 0,
//   };

//   const contentWrapperStyle = {
//     position: 'relative',
//     zIndex: 1,
//   };

//   const headerStyle = {
//     marginBottom: '3rem',
//     textAlign: 'center',
//     padding: '2rem',
//     background: 'rgba(255, 255, 255, 0.15)',
//     backdropFilter: 'blur(25px)',
//     borderRadius: '2rem',
//     border: '1px solid rgba(255, 255, 255, 0.2)',
//     boxShadow: '0 20px 40px rgba(0, 0, 0, 0.1), inset 0 1px 0 rgba(255, 255, 255, 0.3)',
//     position: 'relative',
//     overflow: 'hidden',
//     animation: 'slideInDown 0.8s ease-out',
//   };

//   const titleStyle = {
//     fontSize: '3rem',
//     fontWeight: 900,
//     marginBottom: '0.5rem',
//     color: '#1f2937',
//     position: 'relative',
//     zIndex: 2,
//     letterSpacing: '1px',
//     margin: 0,
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     gap: '1rem',
//   };

//   const headerSubtitleStyle = {
//     fontSize: '1.2rem',
//     fontWeight: 500,
//     position: 'relative',
//     zIndex: 2,
//     color: '#6b7280',
//     margin: 0
//   };

//   const headerIconsStyle = {
//     display: 'flex',
//     justifyContent: 'center',
//     gap: '1rem',
//     marginTop: '1.5rem',
//     position: 'relative',
//     zIndex: 2,
//   };

//   const gridContainerStyle = {
//     display: 'grid',
//     gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
//     gap: '1.5rem',
//   };

//   // ---------- CSS Keyframes ----------
//   const keyframesStyle = `
//     @keyframes slideInDown {
//       from {
//         opacity: 0;
//         transform: translateY(-30px);
//       }
//       to {
//         opacity: 1;
//         transform: translateY(0);
//       }
//     }

//     @keyframes fadeInUp {
//       from {
//         opacity: 0;
//         transform: translateY(30px);
//       }
//       to {
//         opacity: 1;
//         transform: translateY(0);
//       }
//     }

//     @keyframes pulse {
//       0%, 100% { transform: scale(1); }
//       50% { transform: scale(1.05); }
//     }
//   `;

//   const cardStyle = {
//     backgroundColor: 'white',
//     borderRadius: '1rem',
//     padding: '2rem',
//     border: '1px solid #e5e7eb',
//     boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
//     transition: 'all 0.3s ease',
//     position: 'relative',
//     zIndex: 2,
//   };

//   const cardHoverStyle = {
//     transform: 'translateY(-8px)',
//     boxShadow: '0 20px 40px rgba(0, 0, 0, 0.15)',
//   };

//   const projectBadgeStyle = {
//     display: 'inline-block',
//     backgroundColor: '#f0f9ff',
//     border: '1px solid #bae6fd',
//     borderRadius: '0.5rem',
//     padding: '0.5rem 0.75rem',
//     margin: '0.25rem 0.5rem 0.25rem 0',
//     fontSize: '0.75rem',
//     color: '#0c4a6e',
//     fontWeight: 600,
//     boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
//     transition: 'all 0.2s ease',
//     cursor: 'pointer',
//   };

//   const employeeInfoStyle = {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '0.5rem',
//     margin: '0.5rem 0',
//     color: '#475569',
//     fontSize: '0.9rem',
//   };

//   const employeeNameStyle = {
//     margin: '0 0 1rem 0',
//     color: '#1f2937',
//     fontSize: '1.5rem',
//     fontWeight: 700,
//     display: 'flex',
//     alignItems: 'center',
//     gap: '0.5rem',
//   };

//   const sectionTitleStyle = {
//     color: '#1f2937',
//     fontSize: '1rem',
//     fontWeight: 600,
//     margin: '1.5rem 0 0.75rem 0',
//     display: 'flex',
//     alignItems: 'center',
//     gap: '0.5rem',
//   };

//   // -------------------- Fetch Data --------------------
//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const token = localStorage.getItem('authToken');
//         let COMPANY_ID = '';

//         if (token) {
//           try {
//             const decodedToken = jwtDecode(token);
//             // COMPANY_ID = decodedToken.companyId;

//             COMPANY_ID=  decodedToken.role === 'company' 
//             ? (decodedToken.companyId || decodedToken.id) 
//             : decodedToken.companyId;


//             console.log('Decoded Token:', decodedToken);
//           } catch (err) {
//             console.error('Error decoding token:', err);
//           }
//         }

//         const [employeesResponse, projectsResponse, departmentsResponse] = await Promise.all([
//           fetch(`https://slateblue-mallard-430836.hostingersite.com/api/employees/company/${COMPANY_ID}`, {
//             headers: {
//               Authorization: `Bearer ${token}`,
//               'Content-Type': 'application/json',
//             },
//           }),
//           fetch('https://slateblue-mallard-430836.hostingersite.com/api/projectsmgnt', {
//             headers: {
//               Authorization: `Bearer ${token}`,
//               'Content-Type': 'application/json',
//             },
//           }),
//           fetch(`https://slateblue-mallard-430836.hostingersite.com/api/departments/company/${COMPANY_ID}`),
//         ]);

//         let employeesData = [];
//         let projectsData = [];
//         let departmentsData = [];

//         if (employeesResponse.ok) {
//           employeesData = await employeesResponse.json();
//         } else {
//           console.error('Employees fetch failed:', employeesResponse.status, employeesResponse.statusText);
//         }

//         if (projectsResponse.ok) {
//           projectsData = await projectsResponse.json();
//         } else {
//           console.error('Projects fetch failed:', projectsResponse.status, projectsResponse.statusText);
//         }

//         if (departmentsResponse.ok) {
//           departmentsData = await departmentsResponse.json();
//         } else {
//           console.error('Departments fetch failed:', departmentsResponse.status, departmentsResponse.statusText);
//         }

//         setEmployees(Array.isArray(employeesData) ? employeesData : employeesData.data || []);
//         setProjects(Array.isArray(projectsData) ? projectsData : projectsData.data || []);
//         setDepartments(Array.isArray(departmentsData) ? departmentsData : departmentsData.data || []);
//       } catch (error) {
//         console.error('Error fetching data:', error);
//         setEmployees([]);
//         setProjects([]);
//         setDepartments([]);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, []);

//   // -------------------- Helper Functions --------------------
//   const getEmployeeProjects = (employeeId) => {
//     return projects.filter((project) => {
//       if (!Array.isArray(project.teamMembers)) return false;
//       return project.teamMembers.some((member) => {
//         const memberId = typeof member === 'object' ? member._id : member;
//         return String(memberId) === String(employeeId);
//       });
//     });
//   };

// const handleProjectClick = (projectId) => {
//   if (onNavigate) {
//     onNavigate(`/projects/${projectId}`, 'Project Details');  // Navigates to ProjectView for this project
//   } else {
//     console.error('onNavigate prop not provided');
//   }
// };

//   const handleEmployeeCardClick = (employee) => {
//     const employeeId = employee._id;
//     const employeeName = employee.teamMemberName || employee.name || 'Unknown Employee';

//     if (onNavigate) {
//       // Use URL parameters for employee filtering (compatible with FranchiseDashboard)
//       onNavigate(`/projects?employeeId=${employeeId}&employeeName=${encodeURIComponent(employeeName)}`, 'Projects');
//     } else {
//       // Fallback to state-based navigation
//       const assignedProjects = getEmployeeProjects(employee._id);
//       navigate('/projects', { 
//         state: { 
//           employeeFilter: {
//             id: employee._id,
//             name: employeeName,
//             projects: assignedProjects
//           }
//         }
//       });
//     }
//   };

//   // -------------------- Loading State --------------------
//   if (loading) {
//     return (
//       <>
//         <style>{keyframesStyle}</style>
//         <div style={containerStyle}>
//           <div style={backgroundOverlayStyle}></div>
//           <div style={contentWrapperStyle}>
//             <div style={{
//               ...headerStyle,
//               textAlign: 'center',
//               padding: '3rem',
//             }}>
//               <h1 style={titleStyle}>Loading employees...</h1>
//             </div>
//           </div>
//         </div>
//       </>
//     );
//   }

//   // -------------------- Render --------------------
//   return (
//     <>
//       <style>{keyframesStyle}</style>
//       <div style={containerStyle}>
//         <div style={backgroundOverlayStyle}></div>
//         <div style={contentWrapperStyle}>
//           {/* Header */}
//           <div style={headerStyle}>
//             <h1 style={titleStyle}>
//               <Users size={48} style={{ animation: 'pulse 2s infinite' }} />
//               Team Members
//             </h1>
//             <p style={headerSubtitleStyle}>Manage your workforce with style</p>
//             <div style={headerIconsStyle}>
//               <Sparkles size={24} style={{ animation: 'pulse 2s infinite', color: '#f59e0b' }} />
//               <Star size={24} style={{ animation: 'pulse 2s infinite 0.5s', color: '#3b82f6' }} />
//               <Zap size={24} style={{ animation: 'pulse 2s infinite 1s', color: '#10b981' }} />
//             </div>
//           </div>

//           {/* Employees Grid */}
//           <div style={gridContainerStyle}>
//             {Array.isArray(employees) && employees.length === 0 ? (
//               <div
//                 style={{
//                   gridColumn: '1 / -1',
//                   textAlign: 'center',
//                   color: '#6b7280',
//                   padding: '3rem',
//                   background: 'rgba(255, 255, 255, 0.8)',
//                   backdropFilter: 'blur(10px)',
//                   borderRadius: '1.5rem',
//                   border: '1px solid rgba(255, 255, 255, 0.2)',
//                   boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)',
//                 }}
//               >
//                 <Users size={48} style={{ marginBottom: '1rem', opacity: 0.5 }} />
//                 <h3 style={{ margin: '0 0 0.5rem 0', fontSize: '1.5rem', fontWeight: 600 }}>No employees found</h3>
//                 <p style={{ margin: 0, fontSize: '1rem' }}>Add your first employee to get started.</p>
//               </div>
//             ) : (
//               employees.map((employee, index) => {
//                 const assignedProjects = getEmployeeProjects(employee._id);

//                 return (
//                   <div
//                     key={employee._id}
//                     style={{
//                       ...cardStyle,
//                       animation: `fadeInUp 0.6s ease-out ${index * 0.1}s both`,
//                       cursor: 'pointer',
//                     }}
//                     onClick={() => handleEmployeeCardClick(employee)}
//                     onMouseEnter={(e) => {
//                       Object.assign(e.currentTarget.style, {
//                         ...cardStyle,
//                         ...cardHoverStyle,
//                         cursor: 'pointer',
//                       });
//                     }}
//                     onMouseLeave={(e) => {
//                       Object.assign(e.currentTarget.style, {
//                         ...cardStyle,
//                         cursor: 'pointer',
//                       });
//                     }}
//                   >
//                     {/* Employee Name */}
//                     <h3 style={employeeNameStyle}>
//                       <Users size={24} style={{ color: '#3b82f6' }} />
//                       {employee.teamMemberName || employee.name}
//                     </h3>

//                     {/* Employee Details */}
//                     <div style={employeeInfoStyle}>
//                       <Briefcase size={16} style={{ color: '#10b981' }} />
//                       <span><strong>Position:</strong> {employee.role || 'Not specified'}</span>
//                     </div>

//                     <div style={employeeInfoStyle}>
//                       <Mail size={16} style={{ color: '#f59e0b' }} />
//                       <span><strong>Email:</strong> {employee.email}</span>
//                     </div>

//                     {employee.phone && (
//                       <div style={employeeInfoStyle}>
//                         <Phone size={16} style={{ color: '#8b5cf6' }} />
//                         <span><strong>Phone:</strong> {employee.phone}</span>
//                       </div>
//                     )}

//                     {employee.department && (
//                       <div style={employeeInfoStyle}>
//                         <Building2 size={16} style={{ color: '#ef4444' }} />
//                         <span><strong>Department:</strong> {getDepartmentName(employee)}</span>
//                       </div>
//                     )}

//                     {/* Assigned Projects */}
//                     <div style={{ marginTop: '1.5rem' }}>
//                       <h4 style={sectionTitleStyle}>
//                         <Briefcase size={16} style={{ color: '#3b82f6' }} />
//                         Assigned Projects
//                       </h4>
//                       {assignedProjects.length === 0 ? (
//                         <p style={{ 
//                           margin: '0.5rem 0 0', 
//                           color: '#9ca3af', 
//                           fontStyle: 'italic', 
//                           fontSize: '0.9rem',
//                           padding: '1rem',
//                           background: '#f9fafb',
//                           borderRadius: '0.5rem',
//                           border: '1px dashed #d1d5db'
//                         }}>
//                           No projects assigned yet
//                         </p>
//                       ) : (
//                         <div style={{ marginTop: '0.75rem', display: 'flex', flexWrap: 'wrap' }}>
//                           {assignedProjects.map((project) => (
//                             <div 
//                               key={project._id} 
//                               style={projectBadgeStyle}
//                               onClick={(e) => {
//                                 e.stopPropagation();
//                                 handleProjectClick(project._id);
//                               }}
//                               onMouseEnter={(e) => {
//                                 e.currentTarget.style.transform = 'scale(1.05)';
//                                 e.currentTarget.style.boxShadow = '0 4px 8px rgba(0, 0, 0, 0.15)';
//                                 e.currentTarget.style.backgroundColor = '#dbeafe';
//                               }}
//                               onMouseLeave={(e) => {
//                                 e.currentTarget.style.transform = 'scale(1)';
//                                 e.currentTarget.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.1)';
//                                 e.currentTarget.style.backgroundColor = '#f0f9ff';
//                               }}
//                             >
//                               {project.title || project.name}
//                               <span style={{ marginLeft: '0.5rem', opacity: 0.8, fontWeight: 500 }}>
//                                 ({project.status || 'Unknown'})
//                               </span>
//                             </div>
//                           ))}
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 );
//               })
//             )}
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default EmployeeLists;


import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Users, Sparkles, Star, Zap, Mail, Phone, Building2, Briefcase, MapPin, Calendar, Filter, Search, Plus } from 'lucide-react';
import { jwtDecode } from "jwt-decode";
import AlertBox from '../../Components/AlertBox';

const EmployeeLists = ({ onNavigate }) => {
  const navigate = useNavigate();
  const [employees, setEmployees] = useState([]);
  const [projects, setProjects] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAlert, setShowAlert] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [departmentFilter, setDepartmentFilter] = useState('all');
  const [roleFilter, setRoleFilter] = useState('all');

  // Status color mapping
  const statusColors = {
    'Active': 'bg-green-100 text-green-800 border-green-200',
    'Inactive': 'bg-gray-100 text-gray-800 border-gray-200',
    'On Leave': 'bg-yellow-100 text-yellow-800 border-yellow-200',
    'Remote': 'bg-blue-100 text-blue-800 border-blue-200'
  };

  // Role color mapping
  const roleColors = {
    'Manager': 'bg-purple-100 text-purple-800 border-purple-200',
    'Developer': 'bg-blue-100 text-blue-800 border-blue-200',
    'Designer': 'bg-pink-100 text-pink-800 border-pink-200',
    'Analyst': 'bg-orange-100 text-orange-800 border-orange-200',
    'Tester': 'bg-red-100 text-red-800 border-red-200',
    'Admin': 'bg-gray-100 text-gray-800 border-gray-200'
  };

  // Fetch employees from API
  const fetchEmployees = async () => {
    try {
      const token = localStorage.getItem('authToken');
      if (!token) {
        console.error('No access token found');
        return;
      }

      const response = await fetch('https://slateblue-mallard-430836.hostingersite.com/api/employees', {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (response.ok) {
        const data = await response.json();
        setEmployees(Array.isArray(data) ? data : []);
        console.log('Employees fetched:', data);
      } else {
        console.error('Failed to fetch employees:', response.status);
      }
    } catch (error) {
      console.error('Error fetching employees:', error);
    }
  };

  // Fetch departments from API
  const fetchDepartments = async () => {
    try {
      const token = localStorage.getItem('authToken');
      if (!token) {
        console.error('❌ No access token found');
        return;
      }

      console.log('Fetching departments...');

      const response = await fetch('https://slateblue-mallard-430836.hostingersite.com/api/departments', {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      console.log('📊 Departments response status:', response.status);

      if (response.ok) {
        const data = await response.json();
        console.log('✅ Departments data received:', data);
        setDepartments(Array.isArray(data) ? data : []);
      } else {
        console.error('❌ Failed to fetch departments:', response.status, response.statusText);
        // Try to read the error message
        try {
          const errorText = await response.text();
          console.error('❌ Error response:', errorText);
        } catch (e) {
          console.error('❌ Could not read error response');
        }
      }
    } catch (error) {
      console.error('❌ Error fetching departments:', error);
    }
  };

  // Fetch projects from API
  const fetchProjects = async () => {
    try {
      const token = localStorage.getItem('authToken');
      if (!token) {
        console.error('No access token found');
        return;
      }

      const response = await fetch('https://slateblue-mallard-430836.hostingersite.com/api/projectsmgnt', {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (response.ok) {
        const data = await response.json();
        setProjects(Array.isArray(data) ? data : []);
        console.log('Projects fetched:', data);
      } else {
        console.error('Failed to fetch projects:', response.status);
      }
    } catch (error) {
      console.error('Error fetching projects:', error);
    }
  };

  // Load all data on component mount
  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      await Promise.all([
        fetchEmployees(),
        fetchDepartments(),
        fetchProjects()
      ]);
      setLoading(false);
    };

    loadData();
  }, []);

  const getDepartmentName = (employee) => {
    console.log('Getting department for employee:', employee.teamMemberName || employee.name);
    console.log('Employee department data:', employee.department);
    console.log('Available departments count:', departments.length);

    if (!employee.department) return 'N/A';

    // Handle array of departments (most common case based on your data)
    if (Array.isArray(employee.department)) {
      console.log('Department is array with length:', employee.department.length);

      const departmentNames = [];

      employee.department.forEach((dept, index) => {
        console.log(`Processing department ${index}:`, dept);

        if (typeof dept === 'object' && dept !== null) {
          // Department is an object with name
          if (dept.name || dept.departmentName) {
            departmentNames.push(dept.name || dept.departmentName);
            console.log('✅ Found dept name from object:', dept.name || dept.departmentName);
          } else if (dept._id || dept.id) {
            // Department object has ID, look up name
            const deptId = dept._id || dept.id;
            const foundDept = departments.find(d =>
              String(d._id) === String(deptId) ||
              String(d.id) === String(deptId) ||
              String(d.departmentId) === String(deptId)
            );
            if (foundDept) {
              departmentNames.push(foundDept.name || foundDept.departmentName || `Department ${deptId}`);
              console.log('✅ Found dept name from lookup:', foundDept.name || foundDept.departmentName);
            } else {
              departmentNames.push(`Dept ID: ${deptId}`);
              console.log('❌ Dept not found for ID:', deptId);
            }
          }
        } else if (typeof dept === 'string') {
          // Department is a string ID
          const foundDept = departments.find(d =>
            String(d._id) === String(dept) ||
            String(d.id) === String(dept) ||
            String(d.departmentId) === String(dept)
          );
          if (foundDept) {
            departmentNames.push(foundDept.name || foundDept.departmentName || `Department ${dept}`);
            console.log('✅ Found dept name from string lookup:', foundDept.name || foundDept.departmentName);
          } else {
            departmentNames.push(`Dept ID: ${dept}`);
            console.log('❌ Dept not found for string ID:', dept);
          }
        }
      });

      const result = departmentNames.length > 0 ? departmentNames.join(', ') : 'Unknown Department';
      console.log('Final department names:', result);
      return result;
    }

    // Handle single department object
    if (typeof employee.department === 'object' && employee.department !== null) {
      if (employee.department.name || employee.department.departmentName) {
        return employee.department.name || employee.department.departmentName;
      }
      const deptId = employee.department._id || employee.department.id;
      if (deptId) {
        const foundDept = departments.find(d =>
          String(d._id) === String(deptId) ||
          String(d.id) === String(deptId) ||
          String(d.departmentId) === String(deptId)
        );
        return foundDept ? (foundDept.name || foundDept.departmentName || `Department ${deptId}`) : `Dept ID: ${deptId}`;
      }
    }

    // Handle single department string
    if (typeof employee.department === 'string' && employee.department.trim() !== '') {
      const deptId = employee.department.trim();
      const foundDept = departments.find(d =>
        String(d._id) === String(deptId) ||
        String(d.id) === String(deptId) ||
        String(d.departmentId) === String(deptId)
      );
      return foundDept ? (foundDept.name || foundDept.departmentName || `Department ${deptId}`) : `Dept ID: ${deptId}`;
    }

    return 'N/A';
  };

  // Get employee projects
  const getEmployeeProjects = (employeeId) => {
    return projects.filter((project) => {
      if (!Array.isArray(project.teamMembers)) return false;
      return project.teamMembers.some((member) => {
        const memberId = typeof member === 'object' ? member._id : member;
        return String(memberId) === String(employeeId);
      });
    });
  };

  // Handle project click
  const handleProjectClick = (projectId) => {
    if (onNavigate) {
      onNavigate(`/projects/${projectId}`, 'Project Details');
    }
  };

  // Handle employee card click
  const handleEmployeeCardClick = (employee) => {
    const employeeId = employee._id;
    const employeeName = employee.teamMemberName || employee.name || 'Unknown Employee';

    if (onNavigate) {
      onNavigate(`/projects?employeeId=${employeeId}&employeeName=${encodeURIComponent(employeeName)}`, 'Projects');
    } else {
      const assignedProjects = getEmployeeProjects(employee._id);
      navigate('/projects', {
        state: {
          employeeFilter: {
            id: employee._id,
            name: employeeName,
            projects: assignedProjects
          }
        }
      });
    }
  };

  // Filter employees based on search and filters
  const filteredEmployees = employees.filter(employee => {
    const matchesSearch = !searchTerm ||
      (employee.teamMemberName || employee.name || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
      (employee.role || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
      (employee.email || '').toLowerCase().includes(searchTerm.toLowerCase());

    const matchesDepartment = departmentFilter === 'all' ||
      getDepartmentName(employee).toLowerCase().includes(departmentFilter.toLowerCase());

    const matchesRole = roleFilter === 'all' ||
      (employee.role || '').toLowerCase().includes(roleFilter.toLowerCase());

    return matchesSearch && matchesDepartment && matchesRole;
  });

  // Get unique roles for filter
  const uniqueRoles = [...new Set(employees.map(emp => emp.role).filter(Boolean))];

  // Loading state
  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading team members...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50">
      {/* Header (make non-sticky so it doesn't jump/shift while scrolling) */}
      <div className="bg-white/80 backdrop-blur-lg border-b border-gray-200/50 relative z-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="py-6">
            <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
              <div className="flex items-center space-x-4">
                <div className="p-3 bg-gradient-to-r from-blue-500 to-purple-600 rounded-2xl shadow-lg">
                  <Users className="w-8 h-8 text-white" />
                </div>
                {/* <div>
                  <h1 className="text-3xl font-bold text-gray-900">Team Members</h1>
                  <p className="text-gray-600 mt-1">Manage your workforce efficiently</p>
                </div>
              </div>
              <div className="flex items-center space-x-3">



              </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Search and Filters */}
        <div className="bg-white/80 backdrop-blur-lg rounded-2xl shadow-xl border border-gray-200/50 p-6 mb-8">
          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 mb-6">
            <div className="flex-1">
              <div className="relative">
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                <input
                  type="text"
                  placeholder="Search team members by name, role, or email..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 bg-white/50 backdrop-blur-sm"
                />
              </div>
            </div>
            <div className="flex items-center space-x-3">
              <select
                value={departmentFilter}
                onChange={(e) => setDepartmentFilter(e.target.value)}
                className="px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 bg-white/50 backdrop-blur-sm z-10"
              >
                <option value="all">All Departments</option>
                {departments.map(dept => (
                  <option key={dept._id} value={dept._id}>
                    {dept.name || dept.departmentName}
                  </option>
                ))}
              </select>

              <select
                value={roleFilter}
                onChange={(e) => setRoleFilter(e.target.value)}
                className="px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 bg-white/50 backdrop-blur-sm"
              >
                <option value="all">All Roles</option>
                {uniqueRoles.map(role => (
                  <option key={role} value={role}>{role}</option>
                ))}
              </select>
            </div>
          </div>

          {/* Quick Stats */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            <div className="bg-gradient-to-r from-blue-500 to-blue-600 text-white p-4 rounded-xl shadow-lg">
              <div className="text-2xl font-bold">{employees.length}</div>
              <div className="text-blue-100 text-sm">Total Members</div>
            </div>
            <div className="bg-gradient-to-r from-green-500 to-green-600 text-white p-4 rounded-xl shadow-lg">
              <div className="text-2xl font-bold">
                {employees.filter(emp => emp.status === 'Active').length}
              </div>
              <div className="text-green-100 text-sm">Active</div>
            </div>
            <div className="bg-gradient-to-r from-purple-500 to-purple-600 text-white p-4 rounded-xl shadow-lg">
              <div className="text-2xl font-bold">
                {new Set(employees.map(emp => getDepartmentName(emp))).size}
              </div>
              <div className="text-purple-100 text-sm">Departments</div>
            </div>
            <div className="bg-gradient-to-r from-orange-500 to-orange-600 text-white p-4 rounded-xl shadow-lg">
              <div className="text-2xl font-bold">
                {projects.length}
              </div>
              <div className="text-orange-100 text-sm">Total Projects</div>
            </div>
          </div>
        </div>

        {/* Employees Grid */}
        {filteredEmployees.length === 0 ? (
          <div className="bg-white/80 backdrop-blur-lg rounded-2xl shadow-xl border border-gray-200/50 p-12 text-center">
            <div className="text-6xl mb-4">👥</div>
            <h3 className="text-2xl font-bold text-gray-900 mb-2">
              {employees.length === 0 ? "No team members yet" : "No members match your search"}
            </h3>
            <p className="text-gray-600 mb-6">
              {employees.length === 0 ? "Add your first team member to get started." : "Try adjusting your search criteria."}
            </p>
            {employees.length === 0 && (
              <button className="bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white px-8 py-3 rounded-xl font-semibold transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5">
                <Plus className="w-5 h-5 inline mr-2" />
                Add First Member
              </button>
            )}
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
            {filteredEmployees.map((employee, index) => {
              const assignedProjects = getEmployeeProjects(employee._id);
              const employeeStatus = employee.status || 'Active';
              const employeeRole = employee.role || 'Team Member';

              return (
                <div
                  key={employee._id}
                  className="bg-white rounded-2xl shadow-lg border border-gray-200/50 overflow-hidden hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 group cursor-pointer"
                  onClick={() => handleEmployeeCardClick(employee)}
                >
                  {/* Header with gradient */}
                  <div className="bg-gradient-to-r from-blue-500 to-purple-600 p-6 text-white">
                    <div className="flex items-center justify-between mb-4">
                      <div className="flex items-center space-x-3">
                        <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center backdrop-blur-sm">
                          <Users className="w-6 h-6" />
                        </div>
                        <div>
                          <h3 className="text-xl font-bold group-hover:text-blue-100 transition-colors">
                            {employee.teamMemberName || employee.name}
                          </h3>
                          <p className="text-blue-100 text-sm">{employeeRole}</p>
                        </div>
                      </div>
                      <span className={`px-3 py-1 rounded-full text-xs font-semibold ${statusColors[employeeStatus] || 'bg-gray-100 text-gray-800 border-gray-200'}`}>
                        {employeeStatus}
                      </span>
                    </div>

                    {/* Role badge */}
                    <div className="flex flex-wrap gap-2">
                      <span className={`px-2 py-1 rounded-lg text-xs font-semibold ${roleColors[employeeRole] || 'bg-gray-100 text-gray-800 border-gray-200'}`}>
                        {employeeRole}
                      </span>
                      {employee.department && (
                        <span className="px-2 py-1 bg-white/20 rounded-lg text-xs font-semibold backdrop-blur-sm">
                          {getDepartmentName(employee)}
                        </span>
                      )}
                    </div>
                  </div>

                  {/* Employee Details */}
                  <div className="p-6">
                    {/* Contact Information */}
                    <div className="space-y-3 mb-6">
                      <div className="flex items-center space-x-3 text-gray-600">
                        <Mail className="w-4 h-4 text-blue-500" />
                        <span className="text-sm truncate">{employee.email}</span>
                      </div>
                      {employee.phone && (
                        <div className="flex items-center space-x-3 text-gray-600">
                          <Phone className="w-4 h-4 text-green-500" />
                          <span className="text-sm">{employee.phone}</span>
                        </div>
                      )}
                      {employee.location && (
                        <div className="flex items-center space-x-3 text-gray-600">
                          <MapPin className="w-4 h-4 text-red-500" />
                          <span className="text-sm">{employee.location}</span>
                        </div>
                      )}
                    </div>

                    {/* Assigned Projects */}
                    <div className="border-t border-gray-200 pt-4">
                      <div className="flex items-center justify-between mb-3">
                        <h4 className="text-sm font-semibold text-gray-900 flex items-center space-x-2">
                          <Briefcase className="w-4 h-4 text-purple-500" />
                          <span>Assigned Projects</span>
                        </h4>
                        <span className="bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded-full font-semibold">
                          {assignedProjects.length}
                        </span>
                      </div>

                      {assignedProjects.length === 0 ? (
                        <p className="text-gray-500 text-sm text-center py-2 bg-gray-50 rounded-lg border border-dashed border-gray-300">
                          No projects assigned
                        </p>
                      ) : (
                        <div className="space-y-2">
                          {assignedProjects.slice(0, 3).map((project) => (
                            <div
                              key={project._id}
                              onClick={(e) => {
                                e.stopPropagation();
                                handleProjectClick(project._id);
                              }}
                              className="flex items-center justify-between p-3 bg-gray-50 hover:bg-blue-50 rounded-lg border border-gray-200 transition-all duration-200 cursor-pointer group/project"
                            >
                              <div className="flex-1 min-w-0">
                                <p className="text-sm font-medium text-gray-900 truncate">
                                  {project.title || project.name}
                                </p>
                                <p className="text-xs text-gray-500 truncate">
                                  {project.status || 'No status'}
                                </p>
                              </div>
                              <div className="w-2 h-2 bg-green-500 rounded-full ml-2 flex-shrink-0"></div>
                            </div>
                          ))}
                          {assignedProjects.length > 3 && (
                            <p className="text-xs text-gray-500 text-center pt-2">
                              +{assignedProjects.length - 3} more projects
                            </p>
                          )}
                        </div>
                      )}
                    </div>

                    {/* Additional Info */}
                    <div className="flex items-center justify-between text-xs text-gray-500 mt-4 pt-4 border-t border-gray-200">
                      <span>Joined: {employee.createdAt ? new Date(employee.createdAt).toLocaleDateString('en-GB') : 'N/A'}</span>
                      <span>Updated: {employee.updatedAt ? new Date(employee.updatedAt).toLocaleDateString('en-GB') : 'N/A'}</span>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}

        {/* Load More Button */}
        {filteredEmployees.length > 0 && (
          <div className="text-center mt-8">
            <button className="bg-gradient-to-r from-blue-500 to-purple-600 hover:from-blue-600 hover:to-purple-700 text-white px-8 py-3 rounded-xl font-semibold transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5">
              Load More Team Members
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default EmployeeLists;

